"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _theming = _interopRequireDefault(require("../../utils/theming"));

var _messages = require("../../constants/messages");

/**
 * @param idOfMainContent id assigned to main content wrapper, preferably a <Main> tag. Element will need a tabIndex of -1 as well.
 */
function SkipToMainContent(_ref) {
  var idOfMainContent = _ref.idOfMainContent;
  var intl = (0, _reactIntl.useIntl)();

  var text = _react.default.useRef(intl.formatMessage({
    id: _messages.MESSAGE_ID.SKIP_TO_MAIN_CONTENT
  }));

  return _react.default.createElement(HiddenAccessibleAnchor, {
    href: "#".concat(idOfMainContent)
  }, text.current);
}
/**
 * we want to hide the anchor off screen so that you only can access it by tabbing.
 */


var HiddenAccessibleAnchor = (0, _theming.default)('a')({
  left: -2000,
  overflow: 'hidden',
  top: 'auto',
  width: 1,
  zIndex: -999
});
var _default = SkipToMainContent;
exports.default = _default;